import { ExclamationTriangleIcon, ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';
import { useAuth } from '@/contexts/AuthContext';

export function AdminViewBanner() {
  const { user, logout } = useAuth();

  if (!user?.isAdminSession) {
    return null;
  }

  const handleExitAdminView = () => {
    if (user.adminReturnUrl) {
      window.location.href = user.adminReturnUrl;
    } else {
      logout();
    }
  };

  return (
    <div className="flex-shrink-0 w-full bg-yellow-400 border-b-2 border-yellow-600 text-gray-900 py-3 px-4 shadow-md">
      <div className="max-w-full mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <ExclamationTriangleIcon className="h-5 w-5 flex-shrink-0" />
          <div className="flex items-center gap-2 flex-wrap min-w-0">
            <span className="font-bold text-sm">Admin View Mode</span>
            <span className="text-sm truncate">
              Viewing as: <strong>{user.name}</strong> ({user.email})
            </span>
          </div>
        </div>
        <button
          type="button"
          onClick={handleExitAdminView}
          className="flex items-center gap-2 px-4 py-2 bg-gray-900 text-white hover:bg-gray-700 transition-colors rounded font-medium text-sm flex-shrink-0"
        >
          <ArrowRightOnRectangleIcon className="h-4 w-4" />
          Exit
        </button>
      </div>
    </div>
  );
}

export default AdminViewBanner;
